export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname: 'div',
              name: 'Colunas Serviços',
              attributes: { class: 'row-cubo col-sm-reverse' },
              components: [
                {
                  type: 'columnCardService1',
                },
                {
                  type: 'columnService1',
                },
      
              ],
              styles: `
             .row-cubo{
                display: flex; 
                flex-direction:row; 
                width:100%; 
             }
             @media (max-width:992px){
              .row-cubo{
                flex-direction:column;
              }
              .col-sm-reverse{
                flex-direction:column-reverse !important;
              }
             }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};